'use client';

import { getAllBlogPosts } from '@/lib/blog-data';
import BlogCard from '@/components/BlogCard';
import Breadcrumb from '@/components/Breadcrumb';
import { BookOpen, Map, ArrowRight } from 'lucide-react';

export default function BlogPage() {
  const posts = getAllBlogPosts();

  return (
    <div className="mx-auto max-w-7xl px-4 md:px-6 py-8">
      <Breadcrumb items={[
        { label: 'Blog' }
      ]} />
      
      {/* 页面标题 */}
      <div className="mt-8 mb-12">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
            <BookOpen className="h-6 w-6 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-slate-900">Blog</h1>
        </div>
        <p className="text-xl text-slate-600 max-w-3xl leading-relaxed">
          Explore the world of the true size visualizations, cartographic projections, and geographical comparisons. 
          Learn how to see places in the real size and understand the science behind cartographic distortions.
        </p>
      </div>


      {/* 博客文章网格 */}
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>

      {/* 底部信息 */}
      <div className="mt-16">
        <div className="relative bg-gradient-to-br from-sky-50 via-blue-50 to-indigo-100 border border-sky-200 rounded-2xl p-8 md:p-12 overflow-hidden">
          {/* 装饰性背景元素 */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/20 to-purple-400/20 rounded-full -translate-y-16 translate-x-16"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-green-400/20 to-blue-400/20 rounded-full translate-y-12 -translate-x-12"></div>
          
          <div className="relative text-center">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-sky-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
                <Map className="h-8 w-8 text-white" />
              </div>
            </div>
            
            <h2 className="text-3xl font-bold text-slate-900 mb-4">Stay Updated</h2>
            <p className="text-slate-600 mb-8 max-w-2xl mx-auto text-lg leading-relaxed">
              Get the latest insights about true dimensions  visualizations, cartographic projections, and geographical comparisons. 
              We regularly publish articles to help you understand the real scale of places around the world.
            </p>
            
            <div className="flex justify-center">
              <a
                href="/map"
                className="group inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-sky-600 to-blue-700 hover:from-sky-700 hover:to-blue-800 text-white rounded-xl font-semibold text-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <span>Explore TrueSize.World</span>
                <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
